import {
    autocompleteCanonicalAddress,
    autocompleteFullAddress,
    autocompleteLatLngPatch,
    clearUnresolvedAutocompleteLatLngPatch,
} from '@/utilities/address';

import { PICKUP_INFO_FIELDS } from './InputFields';

export const buildPickupInfoAutocompletePatch = (value, split) => ({
    pickupaddress: autocompleteCanonicalAddress(value, split),
    pickupfulladdress: autocompleteFullAddress(value, split),
    [PICKUP_INFO_FIELDS.STREET]: split.street,
    [PICKUP_INFO_FIELDS.CITY]: split.city,
    [PICKUP_INFO_FIELDS.STATE]: split.state,
    [PICKUP_INFO_FIELDS.ZIP]: split.zip,
    // Clear stale weak-choice coords
    ...autocompleteLatLngPatch(split, PICKUP_INFO_FIELDS.LAT, PICKUP_INFO_FIELDS.LONG),
    ...clearUnresolvedAutocompleteLatLngPatch(split, PICKUP_INFO_FIELDS.LAT, PICKUP_INFO_FIELDS.LONG),
});
